import request from '@/utils/comfyUiVideoRequest'

export function genPrompt(data) {
  return request({
    url: 'prompt',
    method: 'post',
    data
  })
}

/**
 * 通过promptId获取视频/文件路径，视频生成和视频反推专用的 prompt API（固定使用 cuda1）
 *
 * @param {*} promptId
 * @returns
 */
export function getVideoPathByPrompt(promptId) {
  return request({
    url: `history/${promptId}`,
    method: 'get'
  })
}
